import gql from 'graphql-tag';

export const FetchVertex = gql`
  query FetchVertexQuery($id: String!) {
    vertex(id: $id) {
      id
      entity {
        _id
        _key
        _class
        _type
        _latest
        _source
        _accountId
        _integrationName
        _integrationDefinitionId
        _integrationInstanceId
        _version
        _createdOn
        _beginOn
        _endOn
        _deleted
        displayName
      }
      properties
    }
  }
`;

export const FetchEdge = gql`
  query FetchEdgeQuery($id: String!) {
    edge(id: $id) {
      id
      toVertexId
      fromVertexId
      relationship {
        _id
        _key
        _type
        _class
        _accountId
        _integrationName
        _integrationDefinitionId
        _integrationInstanceId
        _version
        _createdOn
        _beginOn
        _endOn
        _fromEntityKey
        _toEntityKey
        _fromEntityId
        _toEntityId
        _latest
        _deleted
        displayName
      }
      properties
    }
  }
`;

export const FetchEntityCounts = gql`
  query FetchEntityCounts {
    allEntityCounts
  }
`;

export const ListStandards = gql`
  query ListStandards($size: Int) {
    complianceStandards(size: $size) {
      complianceStandards {
        specification {
          standard
        }
      }
    }
  }
`;

export const GetAuditEvents = gql`
  query Query($limit: Int, $cursor: String) {
    getAuditEventsForAccount(limit: $limit, cursor: $cursor) {
      items {
        id
        resourceType
        resourceId
        category
        timestamp
        performedByUserId
        data
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const EntityRawDataLegacy = gql`
  query GetEntityRawData(
    $entityId: String!
    $source: String!
    $name: String
    $versionId: String
  ) {
    entityRawDataLegacy(
      entityId: $entityId
      source: $source
      name: $name
      versionId: $versionId
    ) {
      entityId
      payload {
        ... on RawDataJSONEntityLegacy {
          contentType
          name
          JSONData: data
        }
        ... on RawDataTextEntityLegacy {
          contentType
          name
          TextData: data
        }
      }
    }
  }
`;

export const EntityRawDataVersionsLegacy = gql`
  query EntityRawDataVersionsLegacy(
    $entityId: String!
    $source: String!
    $name: String!
    $startVersion: String
    $maxResults: Int
  ) {
    entityRawDataVersionsLegacy(
      entityId: $entityId
      source: $source
      name: $name
      startVersion: $startVersion
      maxResults: $maxResults
    ) {
      entityId
      versions {
        versionId
        lastModifiedTimestamp
        sizeBytes
        latest
      }
    }
  }
`;

export const AlertRulePacks = gql`
  query AlertRulePacks {
    alertRulePacks {
      name
      type
      rules {
        name
        description
        queries {
          name
          query
          version
        }
        alertLevel
        templates
      }
    }
  }
`;

export const GetCumulativeAlertsEmailReportRuleInstances = gql`
  query GetCumulativeAlertsEmailReportRuleInstances {
    cumulativeAlertsEmailReportRuleInstances {
      id
      name
      description
      version
      specVersion
      latest
      deleted
      accountId
      pollingInterval
      type
      latestAlertId
      latestAlertIsActive
      operations {
        when
        actions
      }
      outputs
    }
  }
`;
